import {API_BASE_URL, PATH_GROUPS} from '../constants/constants';
import {request, run, getFiltersAsQuery} from "./APIService";

export function getGroups(page, size, filters, clientId) {
    return request({
        url: API_BASE_URL + PATH_GROUPS.replace('{clientId}', clientId) + '?page=' + page + '&size=' + size + '&q=' + getFiltersAsQuery(filters),
        method: 'GET'
    }, []);
}

export function getAllGroups(filters, clientId) {
    return getGroups(0, 100, filters, clientId)
}

export function getGroup(clientId, id) {
    return request({
        url: API_BASE_URL + PATH_GROUPS.replace('{clientId}', clientId) + '/' + id,
        method: 'GET'
    }, []);
}

export function deleteGroup(clientId, id) {
    return run({
        url: API_BASE_URL + PATH_GROUPS.replace('{clientId}', clientId) + '/' + id,
        method: 'DELETE'
    }, []);
}

export function updateGroups(group) {
    if (group.id) {
        return request({
            url: API_BASE_URL + PATH_GROUPS.replace('{clientId}', group.clientId) + "/" + group.id,
            method: 'PUT',
            body: JSON.stringify(group)
        }, []);
    }
    return request({
        url: API_BASE_URL + PATH_GROUPS.replace('{clientId}', group.clientId),
        method: 'POST',
        body: JSON.stringify(group)
    }, []);
}


// WEBPACK FOOTER //
// ./src/app/services/GroupsService.js